<script setup>
import { computed } from 'vue'
import { Calendar, FileEdit, Users } from 'lucide-vue-next'

const props = defineProps({
  toPrepare: {
    type: Number,
    default: 0,
  },
  scheduled: {
    type: Number,
    default: 0,
  },
  activeClients: {
    type: Number,
    default: 0,
  },
})

const cards = computed(() => [
  {
    icon: FileEdit,
    title: 'Rdv à préparer',
    value: props.toPrepare,
  },
  {
    icon: Calendar,
    title: 'Rdv planifiés',
    value: props.scheduled,
  },
  {
    icon: Users,
    title: 'Clients actifs',
    value: props.activeClients,
  },
])
</script>

<template>
  <div class="block">
    <div class="flex gap-4">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="bg-white rounded-lg p-6 flex-1 shadow-sm"
      >
        <div class="flex items-center mb-2">
          <div class="bg-purple-100 p-3 rounded-full mr-3">
            <component :is="card.icon" class="text-purple-600 h-6 w-6" />
          </div>
          <div>
            <p class="text-gray-500 text-sm">
              {{ card.title }}
            </p>
            <p class="text-3xl font-bold text-gray-800">
              {{ card.value }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
